"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_toastify_1 = require("react-toastify");
const elements_1 = require("../../elements");
react_toastify_1.toast.configure();
const SlideAnim = (0, react_toastify_1.cssTransition)({
    enter: 'slideIn',
    exit: 'slideOut',
});
const Toast = (content, options = {}) => {
    const opts = Object.assign({ className: 'toast-notification__background', bodyClassName: 'toast-notification__body', progressClassName: 'toast-notification__progress', closeButton: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "close", className: "toast-notification__close" }, void 0), hideProgressBar: true, autoClose: 5000, position: 'bottom-center', transition: SlideAnim }, options);
    const id = (0, react_toastify_1.toast)((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "toast-notification__content" }, { children: content }), void 0), opts);
    return {
        update: (options) => {
            react_toastify_1.toast.update(id, options);
        },
    };
};
exports.Toast = Toast;
//# sourceMappingURL=Toast.js.map